import React, { Component } from "react";
import "./DetailInput.scss";
import Autocomplete from "../Autocomplete";

class DetailInput extends Component  {
  state= {
    isHebrew: false
  }

  handleChange = event => {
    const { value }  = event.currentTarget;

    this.setState({
      isHebrew: value.search(/[\u0590-\u05FF]/) >= 0
    })
  }

  render(){
    const { className, label, value, type, error, options, onChange ,suffix, onBlur, onFocus, children , ...rest } = this.props;
    return (
      <div className="detail-input">
        {
          type === 'select' ? (
            <Autocomplete defaultInputValue={value} items={options} inputClassName={`detail-input__input ${className || ""}`} input={{ onChange, onBlur, onFocus }} {...rest} />
          ) : (
              <input {...rest}
                onChange={event => {
                this.handleChange(event)
                onChange(event.currentTarget.value)
              }}
                lang={this.state.isHebrew ? 'he' : 'en'}
                onBlur={onBlur}
                onFocus={onFocus}
                type={type || "text"}
                value={value}
                className={`detail-input__input ${className || ""}`} />
            )
        }

        {suffix ? <span>{suffix}</span> : null}
        <span className='detail-input__icon'>{children}</span>
        <label className="detail-input__label">{label}</label>
        <span className="detail-input__bar" />
        {error ? <span className="detail-input__error">{error}</span> : null}
      </div>
    );
  }
};

export default DetailInput;
